var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    ref: "interviewBox",
    staticClass: "interviewParticipate"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    ref: "videoContent",
    staticClass: "videoContent",
    style: {
      width: _vm.videoCanvasWidth
    }
  }, [_c('NewAttendUser', {
    ref: "mainwindow",
    staticClass: "mainWindow",
    attrs: {
      "title": "mainwindow",
      "rtc": _vm.rtc,
      "isAudioLevel": false,
      "liveInfo": _vm.liveInfo[_vm.outputRtilCode],
      "degreeHost": _vm.degreeHost[_vm.outputRtilCode],
      "nickName": _vm.nickNameMap[_vm.outputRtilCode],
      "singChannel": _vm.trackMap[_vm.outputRtilCode],
      "muteAudio": !_vm.State.micStatus[_vm.outputRtilCode],
      "muteVideo": !_vm.State.cameraStatus[_vm.outputRtilCode]
    },
    on: {
      "callback": _vm.dealAttendCallback
    }
  }), _vm.showParticipateList ? _c('div', {
    staticClass: "participateList scrollbar"
  }, _vm._l(_vm.rtilCodeList, function (rtilCode) {
    return _c('NewAttendUser', {
      key: rtilCode,
      ref: `remoteSource${rtilCode}`,
      refInFor: true,
      staticClass: "listLi",
      attrs: {
        "rtc": _vm.rtc,
        "slotNum": _vm.slotNumList[rtilCode],
        "userInfo": _vm.userInfo,
        "isAudioLevel": false,
        "liveInfo": _vm.liveInfo[rtilCode],
        "degreeHost": _vm.degreeHost[rtilCode],
        "nickName": _vm.nickNameMap[rtilCode],
        "singChannel": _vm.trackMap[rtilCode],
        "operateList": _vm.operateList(rtilCode),
        "muteAudio": !_vm.State.micStatus[rtilCode],
        "muteVideo": !_vm.State.cameraStatus[rtilCode],
        "avatar": _vm.avatarInfo[rtilCode] || ''
      },
      on: {
        "callback": _vm.dealAttendCallback
      }
    });
  }), 1) : _vm._e(), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.showParticipateList,
      expression: "!showParticipateList"
    }],
    staticClass: "localVideoBox",
    class: {
      active: !_vm.showLocalVideo
    }
  }, [_c('div', {
    staticClass: "hideVideoBtn",
    on: {
      "click": function ($event) {
        _vm.showLocalVideo = !_vm.showLocalVideo;
      }
    }
  }, [_c('i', {
    class: _vm.showLocalVideo ? 'el-icon-arrow-down' : 'el-icon-arrow-up'
  })]), _c('NewAttendUser', {
    attrs: {
      "slotNum": _vm.slotNumList[_vm.rtilCode],
      "isAudioLevel": false,
      "userInfo": _vm.userInfo,
      "degreeHost": _vm.degreeHost[_vm.rtilCode],
      "singChannel": _vm.trackMap[_vm.rtilCode],
      "nickName": _vm.nickNameMap[_vm.rtilCode],
      "operateList": _vm.operateList(_vm.rtilCode),
      "liveInfo": _vm.liveInfo[_vm.rtilCode],
      "muteAudio": !_vm.State.micStatus[_vm.rtilCode],
      "muteVideo": !_vm.State.cameraStatus[_vm.rtilCode]
    },
    on: {
      "callback": _vm.dealAttendCallback
    }
  }, [_c('div', {
    class: _vm.returnVideoClass,
    attrs: {
      "id": "local_stream"
    }
  })])], 1)], 1)]), _c('Foot', {
    ref: "footDiv",
    attrs: {
      "rtc": _vm.rtc,
      "userInfo": _vm.userInfo,
      "rtilCode": _vm.rtilCode,
      "rtcLoaded": _vm.rtcLoaded,
      "showIconArray": _vm.iconList,
      "devicesInfo": _vm.devicesInfo,
      "mic": _vm.State.micStatus[_vm.rtilCode],
      "camera": _vm.State.cameraStatus[_vm.rtilCode],
      "cameraDevice": _vm.devicesInfo.cameraList,
      "speakerDevice": _vm.devicesInfo.speakerList,
      "microphoneDevice": _vm.devicesInfo.microphoneList
    },
    on: {
      "eventCallback": _vm.dealFootEvent
    }
  }), _c('TipsDailog', {
    attrs: {
      "info": _vm.CameraTips,
      "showClose": false
    },
    on: {
      "save": _vm.setCameraStatus,
      "cancel": () => {
        _vm.sendToHost('camera', 2);
      }
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };